// Keep excluded source rows visible so finance can review and opt them back in.
export function payslipNonEmployeeRow(name) {
    const value = name.trim();
    if (!value)
        return "MISSING_NAME";
    return /^(补充说明|备注|说明|合计|总计|汇总|制表|审核|审批|签字|notes?|total)(?:\s*[:：].*)?\s*$/i.test(value) ? "NOTE_ROW" : null;
}
